module.exports = __webpack_public_path__ + "img/1578802303.d48bb147.jpg";